import { useEffect } from "react";
import { Loader2, Video } from "lucide-react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider";
import { isLoggedin } from "../../lib/isLoggedin";
import { loginRedirectPath } from "../../utils/role.utils";
import StreamViewRecording from "../protected/reports/StreamViewRecording";
import ShakaPlayer from "../../components/public/ShakaPlayer";

const RecordingPlayer = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const type = searchParams.get("type") || "stream";
  const cnr = searchParams.get("cnr") || "";
  const date =
    searchParams.get("date") || searchParams.get("hearingDate") || "";

  useEffect(() => {
    if (!isLoggedin()) {
      navigate(loginRedirectPath(`${location.pathname}${location.search}`), {
        replace: true,
      });
    }
  }, [location.pathname, location.search, navigate]);

  if (!cnr) {
    return (
      <div className="flex min-h-[420px] items-center justify-center rounded-lg border border-slate-200 bg-white px-6 text-center">
        <div>
          <Video className="mx-auto h-9 w-9 text-slate-400" />
          <p className="mt-3 text-sm font-semibold text-slate-800">
            Video details are missing.
          </p>
        </div>
      </div>
    );
  }

  if (!isLoggedin()) {
    return (
      <div className="flex min-h-[420px] items-center justify-center rounded-lg border border-slate-200 bg-white px-6">
        <Loader2 className="h-7 w-7 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="flex min-h-[420px] items-center justify-center rounded-lg border border-slate-200 bg-white px-6">
        <Loader2 className="h-7 w-7 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (type === "recording") {
    const streamBase = import.meta.env.VITE_APP_STREAM_SERVER;
    const streamKey = import.meta.env.VITE_APP_STREAM_KEY;
    const params = new URLSearchParams({ cnr });

    if (date) params.set("hearingDate", date);
    if (streamKey) params.set("key", streamKey);

    return (
      <div className="h-[calc(100vh-96px)] overflow-hidden rounded-lg bg-black">
        <StreamViewRecording
          videoUrl={`${streamBase}/api/stream/video?${params.toString()}`}
          user={user}
          cnr={cnr}
          hearingDate={date}
        />
      </div>
    );
  }

  return (
    <div className="h-[calc(100vh-96px)] overflow-hidden p-6">
      <ShakaPlayer
        src={`https://lorem.video/720p`}
        type="recording"
        watermark={user?.name || user?.email || cnr}
        poster={`https://lorem.video/720p`}
      />
    </div>
  );
};

export default RecordingPlayer;
